/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import Money from 'components/Money/Money';

const BoldText = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

const RedText = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: 'red',
}));

const Highlight = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.primary.main,
}));

const GreenText = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: 'green',
}));

/*
  react-intl calls a tag's renderer once per occurrence and collects the
  results into an array, so every element one returns needs a key — without it
  React warns for any message using a tag more than once. The counter is
  recreated on each render and the tags are visited in document order, so the
  keys stay stable between renders of the same message.
*/
const FormattedTranslationMui = ({ defaultMessage, id, onClick, values }) => {
  let tagIndex = 0;
  const nextKey = () => {
    tagIndex += 1;
    return `tag-${tagIndex}`;
  };
  return (
    <FormattedMessage
      id={id}
      defaultMessage={defaultMessage}
      values={{
        a: chunks => <Link key={nextKey()} onClick={onClick}>{chunks}</Link>,
        red: chunks => <RedText key={nextKey()}>{chunks}</RedText>,
        highlight: chunks => <Highlight key={nextKey()}>{chunks}</Highlight>,
        green: chunks => <GreenText key={nextKey()}>{chunks}</GreenText>,
        bold: chunks => <BoldText key={nextKey()}>{chunks}</BoldText>,
        money: chunks => <Money key={nextKey()} amount={chunks} />,
        newLine: <br />,
        ...values,
      }}
    />
  );
};

FormattedTranslationMui.propTypes = {
  defaultMessage: PropTypes.string,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  values: PropTypes.object,
};

FormattedTranslationMui.defaultProps = {
  defaultMessage: undefined,
  onClick: undefined,
  values: {},
};

export default FormattedTranslationMui;
